import actions from '../../../../../actions/fortnite-game/returnPlayers.actions';
import {getReturnPlayersState} from '../../../../../selectors/fortnite-game/returnPlayersSelector';
import useWidgetData from '../hooks/useWidgetData';

import {WidgetState} from '../../../../../types';
import {WidgetDataParams} from '../types';

const useReturnPlayersData = (params: WidgetDataParams): WidgetState => {
    const widgetData: WidgetState = useWidgetData({
        widgetAction: actions.getReturnPlayers,
        resetAction: actions.resetData,
        getWidgetState: getReturnPlayersState,
        ...params
    });

    return {
        ...widgetData
    };
};

export default useReturnPlayersData;
